<template>
  <section class="entity-activity-provider-">
    <collapsable
      :collapsed="collapsed"
      :title="$t('entities.activities.activities_provided')"
    >
      <div v-if="isFetchingServer">
        <LoadingAnimation class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
      </div>
      <div v-else-if="activities.length">
        <ViewEntitiesByActivity
          :activities="entityActivities"
          :isEditingPersonActivity="false"
          :selectedViewService="authenticationService"
          :availableActivities="activities"
          :editable="editable"
          :limitItems="limitItems !== null ? limitItems : limitItemsByScreenSize"
          :clusters="clusters"
          @update-user-activities="updateEntityActivities"
          >
        </ViewEntitiesByActivity>
      </div>
    </collapsable>
  </section>
</template>
<script>
import Collapsable from '@/components/common/Collapsable'
import LoadingAnimation from '@/components/common/LoadingAnimation'
import ViewActivitiesByEntity from '@/components/users/components/Activities/components/ViewActivitiesByEntity'
import ViewEntitiesByActivity from '@/components/users/components/Activities/components/ViewEntitiesByActivity'
import ScreenSizeMixin from '@/components/users/components/Helpers/ScreenSizeMixin'
import Multiselect from 'vue-multiselect'
import Searchable from '@/components/common/Searchable'
import { mapGetters } from 'vuex'
import { ActivityService, WorkActivityService } from '@/api/AuthService'

export default {
  components: {
    Searchable,
    Collapsable,
    Multiselect,
    LoadingAnimation,
    ViewActivitiesByEntity,
    ViewEntitiesByActivity
  },
  mixins: [
    ScreenSizeMixin
  ],
  props: {
    entity: {
      type: Object,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: false
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    limitItems: {
      type: Number,
      required: false,
      default: 5
    }
  },
  data () {
    return {
      isFetchingServer: true,
      activities: [],
      entityActivities: [],
      entitiesNonRemovable: []
    }
  },
  created () {
    this.loadActivities()
  },
  methods: {
    loadActivities: function () {
      ActivityService.query()
        .then(activities => {
          this.activities = activities
        }).catch((err) => {
          console.error(err)
        })
    },
    loadEntityWorkActivities: function () {
      WorkActivityService.query(this.entity.id)
        .then(workActivites => {
          this.entityActivities = workActivites
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.isFetchingServer = false
        })
    },
    updateEntityActivities: function (payload) {
      WorkActivityService.update(this.entity.id, payload)
        .then(response => {
          this.entityActivities = response.data.data
          const selfProvidedActivities = this.entityActivities.filter(elem => elem.entity.id === this.entity.id)

          this.entity.activity_providers = selfProvidedActivities.map(elem => {
            return {
              activity_id: elem.activity.id,
              entity: elem.entity,
              entity_id: elem.entity.id
            }
          })
          this.entitiesNonRemovable = response.data.entitiesNonRemovable
          if (!this.entitiesNonRemovable.length) {
            this.showToast(this.$t('entities.activities.updated'), this.$store.state.successToastOptions)
          } else {
            this.alertNonRemovableEntities()
          }
        }).catch((err) => {
          console.log(err)
        })
    },
    alertNonRemovableEntities: function () {
      let contentHTML = ``
      this.entitiesNonRemovable.forEach(entityId => {
        let entity = this.authenticationService.entities.find(entity => entity.id === entityId)
        contentHTML += `<li>${entity.name}`
        if (entity.cities.length) {
          contentHTML += ` (${entity.cities[0]})`
        }
        contentHTML += `</li>`
      })
      this.showToast(`
          <div>
            <h6>${this.$t('entities.activities.updated')}</h6>
            ${this.$t('entities.activities.non_removable_entities')}
            <ul>
              ${contentHTML}
            </ul>
          </div>
        `, this.$store.state.infoToastOptions)
      this.entitiesNonRemovable = []
    }
  },
  computed: {
    ...mapGetters([
      'services',
      'clusters'
    ]),
    authenticationService: function () {
      return this.services.find(s => s.url === this.$store.state.evollauth_server)
    },
    limitItemsByScreenSize: function () {
      if (this.windowWidth < 768) {
        return 1
      } else if (this.windowWidth < 1024) {
        return 4
      } else if (this.windowWidth < 1280) {
        return 5
      } else {
        return 6
      }
    }
  },
  watch: {
    entity: {
      handler () {
        this.loadEntityWorkActivities()
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss">
.searchRoles {
  border-radius:20px;
  border-color: #A49D97;
  padding-left:10px;
  border-style: solid;
  padding-right: 18px;
  width: 225px;
  -webkit-transition: all .5s ease;
  -moz-transition: all .5s ease;
  transition: all .5s ease;
}

input.searchRoles{
    outline: none;
    border-color: #29c4a9;
}

.searchRoles::-webkit-outer-spin-button,
.searchRoles::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.search-text-wrapper{
  min-height: 35px;
}

.v-leave { opacity: 1; }
.v-leave-active { transition: opacity 250ms }
.v-leave-to { opacity: 0; }
.v-enter { opacity: 0; }
.v-enter-active  { transition: opacity 250ms }
.v-enter-to { opacity: 1; }

.search-roles-gone{
  cursor: default;
  visibility: none;
  opacity: 0;
  width: 0;
  animation-name: dissapearAnimation;
  animation-duration: 650ms;
}

@keyframes dissapearAnimation {
  0% {
    width: 225px;
  }
  100% {
    width: 0px;
    display: none;
  }
}

@keyframes spin {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(180deg);}
}
</style>
